import * as React from 'react';
import { InputHTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { Font } from '../../fonts';

export interface TextInputWidgetProps {
  value: string;
  onChange: (value: string | null) => any;
  type?: TextInputType;
  submit?: () => any;
  placeholder?: string;
  className?: any;
  mask?: string;
}

export enum TextInputType {
  TEXT = 'text',
  EMAIL = 'email',
  PARAGRAPH = 'paragraph',
  PASS = 'password',
  DATE = 'date'
}

export const TextInputWidget: React.FC<TextInputWidgetProps> = (props) => {
  let type = props.type || TextInputType.TEXT;
  if (type === TextInputType.EMAIL) {
    type = TextInputType.TEXT;
  }

  let attributes: Partial<InputHTMLAttributes<any>> = {
    className: props.className,
    placeholder: props.placeholder,
    type: type,
    value: props.value || '',
    onKeyDown: (event) => {
      if (props.submit && event.key == 'Enter') {
        props.submit();
      }
    },
    onChange: (event) => {
      let v = event.target.value;
      if (v.trim() === '') {
        v = null;
      }
      props.onChange(v);
    }
  };

  if (props.type === TextInputType.EMAIL) {
    attributes = {
      ...attributes,
      autoCorrect: 'off',
      autoCapitalize: 'off'
    };
  }

  if (props.type === TextInputType.PARAGRAPH) {
    return <S.Area {...attributes} />;
  }

  return <S.Input {...attributes} type={props.type || TextInputType.TEXT} />;
};
namespace S {
  export const Input = styled.input`
    background: ${(p) => p.theme.forms.background};
    border: solid 1px ${(p) => p.theme.forms.border};
    border-radius: 3px;
    padding: 10px 10px;
    color: ${(p) => p.theme.forms.foreground};
    outline: none;
    font-family: ${Font.Normal};
    min-width: 250px;
    font-size: 16px;
    box-sizing: border-box;

    ::-webkit-calendar-picker-indicator {
      filter: invert(1);
    }
  `;

  export const Area = styled.textarea`
    background: ${(p) => p.theme.forms.background};
    border: solid 1px ${(p) => p.theme.forms.border};
    border-radius: 3px;
    padding: 10px 10px;
    color: ${(p) => p.theme.forms.foreground};
    outline: none;
    font-family: ${Font.Normal};
    min-width: 100%;
    width: 100%;
    max-width: 100%;
    font-size: 16px;
    box-sizing: border-box;
  `;
}
